window.set = set;
var set = null ;
window.set_is = set_is;
var set_is = null ;

window.debug = debug;
/**
 * debug
 * @param {string} param
 */
function debug(param) {
 	if (typeof console !== 'undefined') {
		console.log(param);
	}
}

window.Hashtable = Hashtable;
function Hashtable() {
	this.items = [];
	this.itemsCount=0;

	this.set = function(key,value) {
		if(!this.containsKey(key))
		{
			this.itemsCount++;
		}
		this.items[key]=value;
	};

	this.get=function(key) {
		if( this.containsKey( key ) ) {
			return this.items[ key ];
		}
		return null;
	};

	this.remove = function(key) {
		if(this.containsKey(key))
		{
			delete this.items[key];
			this.itemsCount--;
		}
	};
	this.containsKey= function(key) {
		return typeof(this.items[key]) !== "undefined";
	};
	this.containsValue = function(value) {
		for (var item in this.items)
		{
			if(this.items[item]==value)
				return true;
		}
		return false;
	};
	this.contains = function(keyOrValue) {
		return this.containsKey(keyOrValue) || this.containsValue(keyOrValue);
	};
	this.clear = function() {
		this.items=[];
		this.itemsCount=0;
	};
	this.size = function() {
		return this.itemsCount;
	};
	this.isEmpty = function() {
		return this.size()==0;
	};
	this.each = function( callback ) {
		for( var key in this.items ) {
			callback.call( this.items[key], this.items[key] ); // set this to the item
		}
	};
	this.first = function() {
		for( var key in this.items ) {
			return this.items[key];
		}
	}
}

window.resize = resize;
function resize(size) {
	$('#content').not( 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7' ).css( 'font-size', size + 'em' ) ;
	document.cookie = 'font_size=' + size + '; path=/';
}

window.set_font_size = set_font_size;
function set_font_size() {
	var cookie_val ;
	cookie_val = get_cookie( 'font_size' ) ;
	if( cookie_val != undefined ) {
		resize( cookie_val ) ;
	}
}

window.get_cookie = get_cookie;
function get_cookie(name){
	var cookies = document.cookie.split(";") ;
	for ( var i = 0; i < cookies.length; i++ ) {
    	var onecookie = cookies[i].split( "=" ) ;
        if ( jQuery.trim( onecookie[0] ) == jQuery.trim( name ) ) {
        	return onecookie[1] ;
        }
    }
}

window.change_design = change_design;
function change_design(design) {
	app.ajax_request( {
		url:	app.get_url( 'changeDesign', null, 'account' ),
		data:	{
			design: design
		},
		success: function() {
			app.reload();
		}
	});
}

window.set_selected_row = set_selected_row;
function set_selected_row( tr ) {
	if( $(tr).hasClass("highlight") ) {
		$(tr).removeClass("highlight");
		$(tr).find( 'input' ).prop('checked', false);
	} else {
		$(tr).addClass("highlight");
		$(tr).find( 'input' ).prop('checked', true);
	}
	return false ;
}

window.get_selected_url = get_selected_url;
function get_selected_url( url, param, table, select, el_count, select2, select3 ) {
	var selected_items = [] ;
	var el = $('#' + table).find( 'tr.highlight' ) ;
	if( el.length < 1) {
		app.error_message( app.get_lang('no_item_selected') ) ;
	} else if( el_count != undefined && el.length != el_count ) {
		app.error_message( app.get_lang('only_one_item_selected') ) ;
	} else {
		el.each( function (i) {
			selected_items.push( this.id.substr(2) );
		} );
		window.location.href = url + ( ( url.match(/\?/) ) ? '&' : '?' ) + param + '=' + selected_items.join( ',' ) + ( ( select != undefined ) ? '&' + select + '=' + $('#' + select).val() : '' ) + ( ( select2 != undefined ) ? '&' + select2 + '=' + $('#' + select2).val() : '' ) + ( ( select3 != undefined ) ? '&' + select3 + '=' + $('#' + select3).val() : '' ) ;
	}
}

window.selectedItemsAjax = selectedItemsAjax;
function selectedItemsAjax( url, itemParam, table, dataFormSelector, ajaxCallback ) {
	var selected_items = [] ;
	var el = $('#' + table).find( 'tr.highlight' ) ;
	if( el.length < 1) {
		app.error_message( app.get_lang('no_item_selected') ) ;
	} else {
		el.each( function (i) {
			selected_items.push( this.id.substr(2) );
		} );
		var data = app.serializeForm( dataFormSelector );
		data[ itemParam ] = selected_items.join( ',' );
		var options = {
				data:		data,
				url :		url,
				success:	ajaxCallback
			};

		app.ajax_request( options );
	}
}

window.select_all = select_all;
function select_all( table ) {
	$('#' + table + ' > tbody > tr' ).not(".head,.t-expense,.t-tank,.t-sum,.t-border").addClass("highlight");
	$('#' + table).find( 'input[type=checkbox]' ).attr('checked', true);
}

window.unselect_all = unselect_all;
function unselect_all( table ) {
	$('#' + table + ' > tbody > tr' ).not(".head,.t-expense,.t-tank,.t-sum,.t-border").removeClass("highlight");
	$('#' + table).find( 'input[type=checkbox]' ).attr('checked', false);
}

window.object_to_array = object_to_array;
function object_to_array( obj ) {
	var arr = [];
	for ( var key in obj) {
		arr[ key ] = obj[key];
	}
	return arr;
}

window.load_tab = load_tab;
function load_tab( url, targetSelector, selector ) {
	var options = {
		url: url,
		success: function() {
			if( selector ) {
				$( selector ).accordion( "refresh" );
			}
			global.tabChangeComplete = true;
		}
	};
	global.tabChangeComplete = false;
	app.ajax_request( options, targetSelector );
}

window.geozone_edit = geozone_edit;
/**
 * edit geozone to assign to an object
 *
 * @param {float} lat
 * @param {float} lng
 * @param {int} geozone_id
 * @param {Object} post_params	additional post params
 */
function geozone_edit( lat, lng, geozone_id, post_params, closeCallback ) {
	app.disableRefresh();
	$( '#default_dialog .contents' ).html( app.get_lang('loading') );

	var url = app.get_url( 'geozoneEditWindow', {}, 'map' );

	app.destroyDialog( '#default_dialog' );
	$( '#default_dialog' ).dialog( {
		modal : false,
		closeOnEscape : true,
		position : { my: "right", at: "right", of: window },
		draggable : true,
		title : app.get_lang( 'geozone.edit.title' ),
		width : 900,
		height : 510,
		close : function() {
			$( this ).dialog( 'destroy' );
			if( closeCallback ) {
				closeCallback()
			}
		},
		open : function( event, ui ) {
			$( '#default_dialog' ).css( 'padding', '0' );
			var data = {
				lat : lat,
				lon : lng,
				id : geozone_id
			};
			if ( typeof post_params === 'object' ) {
				data = jQuery.extend(data, post_params);
			}

			var options = {
				data: data,
				url : url
			};

			app.ajax_request( options, '#default_dialog .contents' );
		}
	} );
}

window.set_lang = set_lang;
function set_lang( lang ) {
	window.location.href = app.get_current_url( '', { newlang: lang } ) ;
}

window.input_duplicate = input_duplicate;
function input_duplicate( input_id) {
	var contents = $('#div_input_'+input_id).html();
	var new_id = Math.round( Math.random() * 100000 );
	contents = contents.replace( new RegExp( input_id, 'g' ), new_id );
	$('#div_input_'+input_id).after( '<div id="div_input_' + new_id + '">' + contents + '</div>' );
	$('#div_input_'+new_id + ' .multi_input').val( '' );
}

window.input_delete = input_delete;
function input_delete( input_id ) {
	if ( $('.multi_input').size() > 1 ) {
		$('#div_input_'+input_id).remove();
	}else {
		$('#div_input_'+input_id + ' .multi_input').val( '' );
	}
}

window.autocomplete_select = autocomplete_select;
/**
 * defautl action after select event in autocompleter
 */
function autocomplete_select( event, ui ) {
	var inputId = event.target.id;
	var hiddenId = inputId.replace('_auto', '');
	$('#' + hiddenId).val( ui.item.id );
	$('#' + hiddenId + '_auto').val( '' );
	$('#' + hiddenId + '_auto').trigger('change');
	$('#' + hiddenId + '_auto_result').html( ui.item.value );
	return false;
}

window.addressAutocomplete = addressAutocomplete;
function addressAutocomplete( event, ui ) {
	var inputId = event.target.id.escapeRegExp();
	var hiddenId = inputId.replace( '_auto', '' );

	$( '#' + hiddenId ).val( ui.item.label );
	$( '#' + inputId ).val( ui.item.label ).trigger( 'change' );

	return false;
}

window.multi_autocomplete_select = multi_autocomplete_select;
function multi_autocomplete_select( event, ui ) {
	var inputId = event.target.id;
	var hiddenId = inputId.replace('_auto', '');

	var dummyDiv = $('#' + hiddenId + '_dummy'), cloned = $( dummyDiv ).clone();
	// insert new after this
	cloned.removeAttr( 'id' );
	cloned.insertBefore( dummyDiv );
	cloned.show();

	cloned.find( 'input[type="hidden"]' ).val( ui.item.id );
	cloned.find( '.item_delete' ).after( ui.item.value );
	$('#' + hiddenId + '_auto').val( '' );

	return false;
}

window.openMessageDialog = openMessageDialog;
function openMessageDialog( handler, id, entityTitle ) {
	app.dialog( app.get_url( "messageHistory", null, "application" ),
		{	id: id,
			handler: handler
		},
		{
			title: app.get_lang("system.message.dialog.title") +": "+ entityTitle,
			width:	700,
			minHeight:	300
		} );
}

/**
 * inherits methods and properties on a parent
 * uber method = parent
 */
Function.prototype.inherits = function (parent) {
    var d = {}, p = (this.prototype = new parent());
    this.prototype.uber = function uber(name) {
        if (!(name in d)) {
            d[name] = 0;
        }
        var f, r, t = d[name], v = parent.prototype;
        if (t) {
            while (t) {
                v = v.constructor.prototype;
                t -= 1;
            }
            f = v[name];
        } else {
            f = p[name];
            if (f == this[name]) {
                f = v[name];
            }
        }
        d[name] += 1;
        r = f.apply(this, Array.prototype.slice.apply(arguments, [1]));
        d[name] -= 1;
        return r;
    };
    return this;
};

/**
 * inherit only needed methods
 * params = 'method1', 'm2', ....
 */
Function.prototype.swiss = function (parent) {
    for (var i = 1; i < arguments.length; i += 1) {
        var name = arguments[i];
        this.prototype[name] = parent.prototype[name];
    }
    return this;
};
window.monitorSms = monitorSms;
function monitorSms( smsId, options ) {
	options.id = smsId;

	app.ajax_request( {
		url:		app.get_url( 'checkSms', null, 'gsm' ),
		data:		options,
		global:		false
	}, options.container );
}

window.firstUpper = firstUpper;
/**
 * @param {string} string
 * @returns {string}
 */
function firstUpper( string ) {
	return string.substr(0, 1).toUpperCase() + string.substr(1);
}

window.entityEditDefault = entityEditDefault;
function entityEditDefault( entity_id, entityString, entityClass, options, entityName, ajax_data, pluginUrl ) {

	options = options || {};

	var dialog_title = entity_id ? entityString + '.form.edit' : entityString + '.form.add';
	var url = entity_id ? entityClass + 'Edit' : entityClass + 'Add',
		container = '#default_dialog';

	app.destroyDialog( container );

	$( container ).addClass( entityClass + '_dialog' );
	$( container + ' .contents' ).html( app.get_lang( 'loading' ) );
	$( container ).dialog( {
		modal : false,
		closeOnEscape : false,
		position : { my: "top", at: "top+50", of: window },
		draggable : true,
		title : app.get_lang( dialog_title ) + ( entityName ? ': ' + entityName : '' ),
		width : options.width || 650,
		minWidth : options.minWidth || 650,
		minHeight: options.minHeight || 150,
		close : function() {
			$( this ).dialog( 'destroy' );
			$("#form_hint").hide();
		},
		open : function( event, ui ) {
			var options = {
					data : {
						id : entity_id
					},
					url : app.get_url( url, null, pluginUrl )
			};
			if( ajax_data ) {
				app.extendObjectProperties( options.data, ajax_data );
			}
			app.ajax_request( options, container + ' .contents' );
		}

	} );
}
window.entityEdit = entityEdit;
function entityEdit( entity_id, entity_class, options, entityName, ajax_data, pluginUrl ) {

	options = options || {};

	var dialog_title = entity_id ? entity_class + '.form.edit' : entity_class + '.form.add';
	var url = entity_id ? entity_class + 'Edit' : entity_class + 'Add';

	app.destroyDialog( '#' + entity_class + '_dialog' );
	$( '#' + entity_class + '_dialog .contents' ).html( app.get_lang( 'loading' ) );
	$( '#' + entity_class + '_dialog' ).dialog( {
		modal : false,
		closeOnEscape : false,
		position : { my: "top", at: "top+50", of: window },
		draggable : true,
		title : app.get_lang( dialog_title ) + ( entityName ? ': ' + entityName : '' ),
		width : options.width || 650,
		minWidth : options.minWidth || 650,
		minHeight: options.minHeight || 150,
		close : function() {
			$( this ).dialog( 'destroy' );
			$("#form_hint").hide();
		},
		open : function( event, ui ) {
			var options = {
				data : {
					id : entity_id
				},
				url : app.get_url( url, null, pluginUrl )
			};
			if( ajax_data ) {
				app.extendObjectProperties( options.data, ajax_data );
			}
			app.ajax_request( options, '#' + entity_class + '_dialog .contents' );
		}

	} );
}

window.LazyLoader = LazyLoader;
function LazyLoader( options ) {
	this.currentOrder = 0;
	this.js =		[];
	this.css =		[];
	this.success =	function() {};
	this.error =	function() {};

	app.extend_object( this, options );

	this.jsNum = this.js.length;

	this.filesLoaded = 0;
	this.jsFilesLoaded = 0;

	this.loadJs();
	this.loadCss();

	if( !this.jsNum && this.success ) { // only css
		this.success();
	}
}

LazyLoader.prototype.loadJs = function() {
	if( !this.js[ this.currentOrder ] ) {
		return;
	}

	if( this.filesLoaded > 50 ) {
		return; // safety check
	}

	this.filesLoaded++;
	//app.debug('curr order:' + this.currentOrder )
	var this_ = this, url = this.js[ this.currentOrder ];

	//app.debug('curr order +')
	this.currentOrder++;

	if( jQuery.inArray( url, app.loadedFiles ) != -1 ) { // already loaded
		//app.debug('already loaded ' + url)
		this.loadJsCallback();

	}else{
		//app.debug('loading ' + url)
		$.ajax({
			url: url,
			success: function(data, textStatus) {
				app.loadedFiles.push( url );
				this_.loadJsCallback();
			},
			dataType: 'script',
			global: false,
			cache: true
		} );
	}
};

LazyLoader.prototype.loadJsCallback = function() {
	if( isNaN( this.jsFilesLoaded ) ) {
		app.debug('js files nan');
		return;
	}

	this.jsFilesLoaded++;
/*	app.debug('file success')
	app.debug( this.jsFilesLoaded )
	app.debug( this.jsNum )*/
	if( this.jsFilesLoaded == this.jsNum ) {
		//app.debug('succ')
		this.success();
	}else{
		this.loadJs();
	}
};

LazyLoader.prototype.loadCss = function() {
	$.each( this.css, function(i, href){

        if ( $('link[href*="'+href+'"]').length ) {
            return;
		}
		//app.debug('loading css ' + href)
        var link = $('<link rel="stylesheet" type="text/css" media="all" href="' + href + '"/>')[0];
        var head = document.getElementsByTagName("head")[0];
        head.appendChild(link);
	});
};

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

String.prototype.escapeRegExp = function () {
	var target = this;
	return target.replace( /([.*+?^=~!:${}()|\[\]\/\\])/g, "\\$1" );
};

String.prototype.accentFold = function () {
	var target = this;
	if (!target) {
		return '';
	}
	var accentMap={'ẚ':'a','Á':'a','á':'a','À':'a','à':'a','Ă':'a','ă':'a','Ắ':'a','ắ':'a','Ằ':'a','ằ':'a','Ẵ':'a','ẵ':'a','Ẳ':'a','ẳ':'a','Â':'a','â':'a','Ấ':'a','ấ':'a','Ầ':'a','ầ':'a','Ẫ':'a','ẫ':'a','Ẩ':'a','ẩ':'a','Ǎ':'a','ǎ':'a','Å':'a','å':'a','Ǻ':'a','ǻ':'a','Ä':'a','ä':'a','Ǟ':'a','ǟ':'a','Ã':'a','ã':'a','Ȧ':'a','ȧ':'a','Ǡ':'a','ǡ':'a','Ą':'a','ą':'a','Ā':'a','ā':'a','Ả':'a','ả':'a','Ȁ':'a','ȁ':'a','Ȃ':'a','ȃ':'a','Ạ':'a','ạ':'a','Ặ':'a','ặ':'a','Ậ':'a','ậ':'a','Ḁ':'a','ḁ':'a','Ⱥ':'a','ⱥ':'a','Ǽ':'a','ǽ':'a','Ǣ':'a','ǣ':'a','Ḃ':'b','ḃ':'b','Ḅ':'b','ḅ':'b','Ḇ':'b','ḇ':'b','Ƀ':'b','ƀ':'b','ᵬ':'b','Ɓ':'b','ɓ':'b','Ƃ':'b','ƃ':'b','Ć':'c','ć':'c','Ĉ':'c','ĉ':'c','Č':'c','č':'c','Ċ':'c','ċ':'c','Ç':'c','ç':'c','Ḉ':'c','ḉ':'c','Ȼ':'c','ȼ':'c','Ƈ':'c','ƈ':'c','ɕ':'c','Ď':'d','ď':'d','Ḋ':'d','ḋ':'d','Ḑ':'d','ḑ':'d','Ḍ':'d','ḍ':'d','Ḓ':'d','ḓ':'d','Ḏ':'d','ḏ':'d','Đ':'d','đ':'d','ᵭ':'d','Ɖ':'d','ɖ':'d','Ɗ':'d','ɗ':'d','Ƌ':'d','ƌ':'d','ȡ':'d','ð':'d','É':'e','Ə':'e','Ǝ':'e','ǝ':'e','é':'e','È':'e','è':'e','Ĕ':'e','ĕ':'e','Ê':'e','ê':'e','Ế':'e','ế':'e','Ề':'e','ề':'e','Ễ':'e','ễ':'e','Ể':'e','ể':'e','Ě':'e','ě':'e','Ë':'e','ë':'e','Ẽ':'e','ẽ':'e','Ė':'e','ė':'e','Ȩ':'e','ȩ':'e','Ḝ':'e','ḝ':'e','Ę':'e','ę':'e','Ē':'e','ē':'e','Ḗ':'e','ḗ':'e','Ḕ':'e','ḕ':'e','Ẻ':'e','ẻ':'e','Ȅ':'e','ȅ':'e','Ȇ':'e','ȇ':'e','Ẹ':'e','ẹ':'e','Ệ':'e','ệ':'e','Ḙ':'e','ḙ':'e','Ḛ':'e','ḛ':'e','Ɇ':'e','ɇ':'e','ɚ':'e','ɝ':'e','Ḟ':'f','ḟ':'f','ᵮ':'f','Ƒ':'f','ƒ':'f','Ǵ':'g','ǵ':'g','Ğ':'g','ğ':'g','Ĝ':'g','ĝ':'g','Ǧ':'g','ǧ':'g','Ġ':'g','ġ':'g','Ģ':'g','ģ':'g','Ḡ':'g','ḡ':'g','Ǥ':'g','ǥ':'g','Ɠ':'g','ɠ':'g','Ĥ':'h','ĥ':'h','Ȟ':'h','ȟ':'h','Ḧ':'h','ḧ':'h','Ḣ':'h','ḣ':'h','Ḩ':'h','ḩ':'h','Ḥ':'h','ḥ':'h','Ḫ':'h','ḫ':'h','H':'h','̱':'h','ẖ':'h','Ħ':'h','ħ':'h','Ⱨ':'h','ⱨ':'h','Í':'i','í':'i','Ì':'i','ì':'i','Ĭ':'i','ĭ':'i','Î':'i','î':'i','Ǐ':'i','ǐ':'i','Ï':'i','ï':'i','Ḯ':'i','ḯ':'i','Ĩ':'i','ĩ':'i','İ':'i','i':'i','Į':'i','į':'i','Ī':'i','ī':'i','Ỉ':'i','ỉ':'i','Ȉ':'i','ȉ':'i','Ȋ':'i','ȋ':'i','Ị':'i','ị':'i','Ḭ':'i','ḭ':'i','I':'i','ı':'i','Ɨ':'i','ɨ':'i','Ĵ':'j','ĵ':'j','J':'j','̌':'j','ǰ':'j','ȷ':'j','Ɉ':'j','ɉ':'j','ʝ':'j','ɟ':'j','ʄ':'j','Ḱ':'k','ḱ':'k','Ǩ':'k','ǩ':'k','Ķ':'k','ķ':'k','Ḳ':'k','ḳ':'k','Ḵ':'k','ḵ':'k','Ƙ':'k','ƙ':'k','Ⱪ':'k','ⱪ':'k','Ĺ':'a','ĺ':'l','Ľ':'l','ľ':'l','Ļ':'l','ļ':'l','Ḷ':'l','ḷ':'l','Ḹ':'l','ḹ':'l','Ḽ':'l','ḽ':'l','Ḻ':'l','ḻ':'l','Ł':'l','ł':'l','Ł':'l','̣':'l','ł':'l','̣':'l','Ŀ':'l','ŀ':'l','Ƚ':'l','ƚ':'l','Ⱡ':'l','ⱡ':'l','Ɫ':'l','ɫ':'l','ɬ':'l','ɭ':'l','ȴ':'l','Ḿ':'m','ḿ':'m','Ṁ':'m','ṁ':'m','Ṃ':'m','ṃ':'m','ɱ':'m','Ń':'n','ń':'n','Ǹ':'n','ǹ':'n','Ň':'n','ň':'n','Ñ':'n','ñ':'n','Ṅ':'n','ṅ':'n','Ņ':'n','ņ':'n','Ṇ':'n','ṇ':'n','Ṋ':'n','ṋ':'n','Ṉ':'n','ṉ':'n','Ɲ':'n','ɲ':'n','Ƞ':'n','ƞ':'n','ɳ':'n','ȵ':'n','N':'n','̈':'n','n':'n','̈':'n','Ó':'o','ó':'o','Ò':'o','ò':'o','Ŏ':'o','ŏ':'o','Ô':'o','ô':'o','Ố':'o','ố':'o','Ồ':'o','ồ':'o','Ỗ':'o','ỗ':'o','Ổ':'o','ổ':'o','Ǒ':'o','ǒ':'o','Ö':'o','ö':'o','Ȫ':'o','ȫ':'o','Ő':'o','ő':'o','Õ':'o','õ':'o','Ṍ':'o','ṍ':'o','Ṏ':'o','ṏ':'o','Ȭ':'o','ȭ':'o','Ȯ':'o','ȯ':'o','Ȱ':'o','ȱ':'o','Ø':'o','ø':'o','Ǿ':'o','ǿ':'o','Ǫ':'o','ǫ':'o','Ǭ':'o','ǭ':'o','Ō':'o','ō':'o','Ṓ':'o','ṓ':'o','Ṑ':'o','ṑ':'o','Ỏ':'o','ỏ':'o','Ȍ':'o','ȍ':'o','Ȏ':'o','ȏ':'o','Ơ':'o','ơ':'o','Ớ':'o','ớ':'o','Ờ':'o','ờ':'o','Ỡ':'o','ỡ':'o','Ở':'o','ở':'o','Ợ':'o','ợ':'o','Ọ':'o','ọ':'o','Ộ':'o','ộ':'o','Ɵ':'o','ɵ':'o','Ṕ':'p','ṕ':'p','Ṗ':'p','ṗ':'p','Ᵽ':'p','Ƥ':'p','ƥ':'p','P':'p','̃':'p','p':'p','̃':'p','ʠ':'q','Ɋ':'q','ɋ':'q','Ŕ':'r','ŕ':'r','Ř':'r','ř':'r','Ṙ':'r','ṙ':'r','Ŗ':'r','ŗ':'r','Ȑ':'r','ȑ':'r','Ȓ':'r','ȓ':'r','Ṛ':'r','ṛ':'r','Ṝ':'r','ṝ':'r','Ṟ':'r','ṟ':'r','Ɍ':'r','ɍ':'r','ᵲ':'r','ɼ':'r','Ɽ':'r','ɽ':'r','ɾ':'r','ᵳ':'r','ß':'s','Ś':'s','ś':'s','Ṥ':'s','ṥ':'s','Ŝ':'s','ŝ':'s','Š':'s','š':'s','Ṧ':'s','ṧ':'s','Ṡ':'s','ṡ':'s','ẛ':'s','Ş':'s','ş':'s','Ṣ':'s','ṣ':'s','Ṩ':'s','ṩ':'s','Ș':'s','ș':'s','ʂ':'s','S':'s','̩':'s','s':'s','̩':'s','Þ':'t','þ':'t','Ť':'t','ť':'t','T':'t','̈':'t','ẗ':'t','Ṫ':'t','ṫ':'t','Ţ':'t','ţ':'t','Ṭ':'t','ṭ':'t','Ț':'t','ț':'t','Ṱ':'t','ṱ':'t','Ṯ':'t','ṯ':'t','Ŧ':'t','ŧ':'t','Ⱦ':'t','ⱦ':'t','ᵵ':'t','ƫ':'t','Ƭ':'t','ƭ':'t','Ʈ':'t','ʈ':'t','ȶ':'t','Ú':'u','ú':'u','Ù':'u','ù':'u','Ŭ':'u','ŭ':'u','Û':'u','û':'u','Ǔ':'u','ǔ':'u','Ů':'u','ů':'u','Ü':'u','ü':'u','Ǘ':'u','ǘ':'u','Ǜ':'u','ǜ':'u','Ǚ':'u','ǚ':'u','Ǖ':'u','ǖ':'u','Ű':'u','ű':'u','Ũ':'u','ũ':'u','Ṹ':'u','ṹ':'u','Ų':'u','ų':'u','Ū':'u','ū':'u','Ṻ':'u','ṻ':'u','Ủ':'u','ủ':'u','Ȕ':'u','ȕ':'u','Ȗ':'u','ȗ':'u','Ư':'u','ư':'u','Ứ':'u','ứ':'u','Ừ':'u','ừ':'u','Ữ':'u','ữ':'u','Ử':'u','ử':'u','Ự':'u','ự':'u','Ụ':'u','ụ':'u','Ṳ':'u','ṳ':'u','Ṷ':'u','ṷ':'u','Ṵ':'u','ṵ':'u','Ʉ':'u','ʉ':'u','Ṽ':'v','ṽ':'v','Ṿ':'v','ṿ':'v','Ʋ':'v','ʋ':'v','Ẃ':'w','ẃ':'w','Ẁ':'w','ẁ':'w','Ŵ':'w','ŵ':'w','W':'w','̊':'w','ẘ':'w','Ẅ':'w','ẅ':'w','Ẇ':'w','ẇ':'w','Ẉ':'w','ẉ':'w','Ẍ':'x','ẍ':'x','Ẋ':'x','ẋ':'x','Ý':'y','ý':'y','Ỳ':'y','ỳ':'y','Ŷ':'y','ŷ':'y','Y':'y','̊':'y','ẙ':'y','Ÿ':'y','ÿ':'y','Ỹ':'y','ỹ':'y','Ẏ':'y','ẏ':'y','Ȳ':'y','ȳ':'y','Ỷ':'y','ỷ':'y','Ỵ':'y','ỵ':'y','ʏ':'y','Ɏ':'y','ɏ':'y','Ƴ':'y','ƴ':'y','Ź':'z','ź':'z','Ẑ':'z','ẑ':'z','Ž':'z','ž':'z','Ż':'z','ż':'z','Ẓ':'z','ẓ':'z','Ẕ':'z','ẕ':'z','Ƶ':'z','ƶ':'z','Ȥ':'z','ȥ':'z','ʐ':'z','ʑ':'z','Ⱬ':'z','ⱬ':'z','Ǯ':'z','ǯ':'z','ƺ':'z','２':'2','６':'6','Ｂ':'B','Ｆ':'F','Ｊ':'J','Ｎ':'N','Ｒ':'R','Ｖ':'V','Ｚ':'Z','ｂ':'b','ｆ':'f','ｊ':'j','ｎ':'n','ｒ':'r','ｖ':'v','ｚ':'z','１':'1','５':'5','９':'9','Ａ':'A','Ｅ':'E','Ｉ':'I','Ｍ':'M','Ｑ':'Q','Ｕ':'U','Ｙ':'Y','ａ':'a','ｅ':'e','ｉ':'i','ｍ':'m','ｑ':'q','ｕ':'u','ｙ':'y','０':'0','４':'4','８':'8','Ｄ':'D','Ｈ':'H','Ｌ':'L','Ｐ':'P','Ｔ':'T','Ｘ':'X','ｄ':'d','ｈ':'h','ｌ':'l','ｐ':'p','ｔ':'t','ｘ':'x','３':'3','７':'7','Ｃ':'C','Ｇ':'G','Ｋ':'K','Ｏ':'O','Ｓ':'S','Ｗ':'W','ｃ':'c','ｇ':'g','ｋ':'k','ｏ':'o','ｓ':'s','ｗ':'w'};
	var rv = '';
	for (var i=0; i<target.length; i++) {
		rv += accentMap[target.charAt(i)] || target.charAt(i);
	}
	return rv;
};

$.fn.googleMap = function (options) {
	var _this = this;

	if( options =='getMap' ) {
		return _this.data('map');
	}

	var settings = $.extend({}, {
		zoom: 5,
		center: {lat:0, lng:0}
	}, options);

	this.initialize = function () {

		var map = new google.maps.Map(_this.get(0), settings);
		_this.data('map', map);

		return _this;
	};

	this.getMap = function () {
		return _this.data('map');
	};

	return this;
};

window.getGeoLocation = getGeoLocation;
function getGeoLocation( positionCallback, errorCallback ) {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition( positionCallback, errorCallback );
	} else {
		return false;
	}
}
window.getIpLocation = getIpLocation;
function getIpLocation( callback ) {
	$.getJSON( "http://api.ipstack.com/" + app.get_config( "output", "ip" ) + "?access_key=3de939c5ec8985884bbebf31596b88d7", callback );
}

window.convertToUTC = convertToUTC;
function convertToUTC(date){
	return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

Date.parseFunctions={count:0};Date.parseRegexes=[];Date.formatFunctions={count:0};Date.prototype.convertToUTC=function(){return new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds()); };Date.prototype.dateFormat=function(b){if(b=="unixtime"){return parseInt(this.getTime()/1000);}if(Date.formatFunctions[b]==null){Date.createNewFormat(b);}var a=Date.formatFunctions[b];return this[a]();};Date.createNewFormat=function(format){var funcName="format"+Date.formatFunctions.count++;Date.formatFunctions[format]=funcName;var codePrefix="Date.prototype."+funcName+" = function() {return ";var code="";var special=false;var ch="";for(var i=0;i<format.length;++i){ch=format.charAt(i);if(!special&&ch=="\\"){special=true;}else{if(special){special=false;code+="'"+String.escape(ch)+"' + ";}else{code+=Date.getFormatCode(ch);}}}if(code.length==0){code="\"\"";}else{code=code.substring(0,code.length-3);}eval(codePrefix+code+";}");};Date.getFormatCode=function(a){switch(a){case"d":return"String.leftPad(this.getDate(), 2, '0') + ";case"D":return"Date.dayNames[this.getDay()].substring(0, 3) + ";case"j":return"this.getDate() + ";case"l":return"Date.dayNames[this.getDay()] + ";case"S":return"this.getSuffix() + ";case"w":return"this.getDay() + ";case"z":return"this.getDayOfYear() + ";case"W":return"this.getWeekOfYear() + ";case"F":return"Date.monthNames[this.getMonth()] + ";case"m":return"String.leftPad(this.getMonth() + 1, 2, '0') + ";case"M":return"Date.monthNames[this.getMonth()].substring(0, 3) + ";case"n":return"(this.getMonth() + 1) + ";case"t":return"this.getDaysInMonth() + ";case"L":return"(this.isLeapYear() ? 1 : 0) + ";case"Y":return"this.getFullYear() + ";case"y":return"('' + this.getFullYear()).substring(2, 4) + ";case"a":return"(this.getHours() < 12 ? 'am' : 'pm') + ";case"A":return"(this.getHours() < 12 ? 'AM' : 'PM') + ";case"g":return"((this.getHours() %12) ? this.getHours() % 12 : 12) + ";case"G":return"this.getHours() + ";case"h":return"String.leftPad((this.getHours() %12) ? this.getHours() % 12 : 12, 2, '0') + ";case"H":return"String.leftPad(this.getHours(), 2, '0') + ";case"i":return"String.leftPad(this.getMinutes(), 2, '0') + ";case"s":return"String.leftPad(this.getSeconds(), 2, '0') + ";case"O":return"this.getGMTOffset() + ";case"T":return"this.getTimezone() + ";case"Z":return"(this.getTimezoneOffset() * -60) + ";default:return"'"+String.escape(a)+"' + ";}};Date.parseDate=function(a,c){if(c=="unixtime"){return new Date(!isNaN(parseInt(a))?parseInt(a)*1000:0);}if(Date.parseFunctions[c]==null){Date.createParser(c);}var b=Date.parseFunctions[c];return Date[b](a);};Date.createParser=function(format){var funcName="parse"+Date.parseFunctions.count++;var regexNum=Date.parseRegexes.length;var currentGroup=1;Date.parseFunctions[format]=funcName;var code="Date."+funcName+" = function(input) {\nvar y = -1, m = -1, d = -1, h = -1, i = -1, s = -1, z = -1;\nvar d = new Date();\ny = d.getFullYear();\nm = d.getMonth();\nd = d.getDate();\nvar results = input.match(Date.parseRegexes["+regexNum+"]);\nif (results && results.length > 0) {";var regex="";var special=false;var ch="";for(var i=0;i<format.length;++i){ch=format.charAt(i);if(!special&&ch=="\\"){special=true;}else{if(special){special=false;regex+=String.escape(ch);}else{obj=Date.formatCodeToRegex(ch,currentGroup);currentGroup+=obj.g;regex+=obj.s;if(obj.g&&obj.c){code+=obj.c;}}}}code+="if (y > 0 && z > 0){\nvar doyDate = new Date(y,0);\ndoyDate.setDate(z);\nm = doyDate.getMonth();\nd = doyDate.getDate();\n}";code+="if (y > 0 && m >= 0 && d > 0 && h >= 0 && i >= 0 && s >= 0)\n{return new Date(y, m, d, h, i, s);}\nelse if (y > 0 && m >= 0 && d > 0 && h >= 0 && i >= 0)\n{return new Date(y, m, d, h, i);}\nelse if (y > 0 && m >= 0 && d > 0 && h >= 0)\n{return new Date(y, m, d, h);}\nelse if (y > 0 && m >= 0 && d > 0)\n{return new Date(y, m, d);}\nelse if (y > 0 && m >= 0)\n{return new Date(y, m);}\nelse if (y > 0)\n{return new Date(y);}\n}return null;}";Date.parseRegexes[regexNum]=new RegExp("^"+regex+"$",'i');eval(code);};Date.formatCodeToRegex=function(b,a){switch(b){case"D":return{g:0,c:null,s:"(?:Sun|Mon|Tue|Wed|Thu|Fri|Sat)"};case"j":case"d":return{g:1,c:"d = parseInt(results["+a+"], 10);\n",s:"(\\d{1,2})"};case"l":return{g:0,c:null,s:"(?:"+Date.dayNames.join("|")+")"};case"S":return{g:0,c:null,s:"(?:st|nd|rd|th)"};case"w":return{g:0,c:null,s:"\\d"};case"z":return{g:1,c:"z = parseInt(results["+a+"], 10);\n",s:"(\\d{1,3})"};case"W":return{g:0,c:null,s:"(?:\\d{2})"};case"F":return{g:1,c:"m = parseInt(Date.monthNumbers[results["+a+"].substring(0, 3)], 10);\n",s:"("+Date.monthNames.join("|")+")"};case"M":return{g:1,c:"m = parseInt(Date.monthNumbers[results["+a+"]], 10);\n",s:"(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)"};case"n":case"m":return{g:1,c:"m = parseInt(results["+a+"], 10) - 1;\n",s:"(\\d{1,2})"};case"t":return{g:0,c:null,s:"\\d{1,2}"};case"L":return{g:0,c:null,s:"(?:1|0)"};case"Y":return{g:1,c:"y = parseInt(results["+a+"], 10);\n",s:"(\\d{4})"};case"y":return{g:1,c:"var ty = parseInt(results["+a+"], 10);\ny = ty > Date.y2kYear ? 1900 + ty : 2000 + ty;\n",s:"(\\d{1,2})"};case"a":return{g:1,c:"if (results["+a+"] == 'am') {\nif (h == 12) { h = 0; }\n} else { if (h < 12) { h += 12; }}",s:"(am|pm)"};case"A":return{g:1,c:"if (results["+a+"] == 'AM') {\nif (h == 12) { h = 0; }\n} else { if (h < 12) { h += 12; }}",s:"(AM|PM)"};case"g":case"G":case"h":case"H":return{g:1,c:"h = parseInt(results["+a+"], 10);\n",s:"(\\d{1,2})"};case"i":return{g:1,c:"i = parseInt(results["+a+"], 10);\n",s:"(\\d{2})"};case"s":return{g:1,c:"s = parseInt(results["+a+"], 10);\n",s:"(\\d{2})"};case"O":return{g:0,c:null,s:"[+-]\\d{4}"};case"T":return{g:0,c:null,s:"[A-Z]{3}"};case"Z":return{g:0,c:null,s:"[+-]\\d{1,5}"};default:return{g:0,c:null,s:String.escape(b)};}};Date.prototype.getTimezone=function(){return this.toString().replace(/^.*? ([A-Z]{3}) [0-9]{4}.*$/,"$1").replace(/^.*?\(([A-Z])[a-z]+ ([A-Z])[a-z]+ ([A-Z])[a-z]+\)$/,"$1$2$3");};Date.prototype.getGMTOffset=function(){return(this.getTimezoneOffset()>0?"-":"+")+String.leftPad(Math.floor(Math.abs(this.getTimezoneOffset())/60),2,"0")+String.leftPad(Math.abs(this.getTimezoneOffset())%60,2,"0");};Date.prototype.getDayOfYear=function(){var a=0;Date.daysInMonth[1]=this.isLeapYear()?29:28;for(var b=0;b<this.getMonth();++b){a+=Date.daysInMonth[b];}return a+this.getDate();};Date.prototype.getWeekOfYear=function(){var b=this.getDayOfYear()+(4-this.getDay());var a=new Date(this.getFullYear(),0,1);var c=(7-a.getDay()+4);return String.leftPad(Math.ceil((b-c)/7)+1,2,"0");};Date.prototype.isLeapYear=function(){var a=this.getFullYear();return((a&3)==0&&(a%100||(a%400==0&&a)));};Date.prototype.getFirstDayOfMonth=function(){var a=(this.getDay()-(this.getDate()-1))%7;return(a<0)?(a+7):a;};Date.prototype.getLastDayOfMonth=function(){var a=(this.getDay()+(Date.daysInMonth[this.getMonth()]-this.getDate()))%7;return(a<0)?(a+7):a;};Date.prototype.getDaysInMonth=function(){Date.daysInMonth[1]=this.isLeapYear()?29:28;return Date.daysInMonth[this.getMonth()];};Date.prototype.getSuffix=function(){switch(this.getDate()){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th";}};String.escape=function(a){return a.replace(/('|\\)/g,"\\$1");};String.leftPad=function(d,b,c){var a=new String(d);if(c==null){c=" ";}while(a.length<b){a=c+a;}return a;};Date.daysInMonth=[31,28,31,30,31,30,31,31,30,31,30,31];Date.monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];Date.dayNames=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];Date.y2kYear=50;Date.monthNumbers={Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11};Date.patterns={ISO8601LongPattern:"Y-m-d H:i:s",ISO8601ShortPattern:"Y-m-d",ShortDatePattern:"n/j/Y",LongDatePattern:"l, F d, Y",FullDateTimePattern:"l, F d, Y g:i:s A",MonthDayPattern:"F d",ShortTimePattern:"g:i A",LongTimePattern:"g:i:s A",SortableDateTimePattern:"Y-m-d\\TH:i:s",UniversalSortableDateTimePattern:"Y-m-d H:i:sO",YearMonthPattern:"F, Y"};

window.isElementInScreen = isElementInScreen;
function isElementInScreen( elem, completly, minVisiblePartPx ) {
	elem = $( elem );
	if( !minVisiblePartPx ) {
		minVisiblePartPx = 20;
	}
	var windowScrollTop = $( window ).scrollTop();
	var windowScrollBottom = windowScrollTop + window.innerHeight;
	var elemTop = elem.offset().top + minVisiblePartPx; // min visible part of element in pixels
	var elemBottom = elemTop + elem.height() - minVisiblePartPx; // min visible part of element in pixels

	var elemInView;
	if( completly ) {
		elemInView = (elemTop < windowScrollTop) && (elemBottom < windowScrollBottom);
	} else {
		var topIn = elemTop > windowScrollTop && elemTop < windowScrollBottom;
		var bottomIn = elemBottom < windowScrollBottom && elemBottom > windowScrollTop;

		elemInView = (topIn || bottomIn);
	}

	return elemInView;
}

window.scrollToElementIfOutOfView = scrollToElementIfOutOfView;
function scrollToElementIfOutOfView(elem){
	elem = $(elem);
	if( elem.length && !isElementInScreen( elem ) ) {
		$( 'html, body' ).animate( {
			scrollTop: elem.offset().top - 60
		}, 500 )
	}
}

window.formatBytes = formatBytes;
function formatBytes( bytes, decimals ) {
	if( bytes == 0 ) {
		return '0 Bytes';
	}
	var k = 1024,
		dm = decimals || 2,
		sizes = [ 'B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ],
		i = Math.floor( Math.log( bytes ) / Math.log( k ) );
	return parseFloat( (bytes / Math.pow( k, i )).toFixed( dm ) ) + ' ' + sizes[ i ];
}